import "src/decidim/forms/forms"

// Images
require.context("../images", true)
